import { Torneo as Filtros } from '../constantes/Filtros.js';

export const Reducer = {
  INICIALIZAR: 'inicializar',
  VOLVER: 'volver',
};

export const ReducerVacio = {
  pais: null,
  tipoTorneo: null,
  categoria: { codigo: 1, descripcion: 'Mayor' },
  division: null,
  torneo: null,
  etapa: null,
  equipo: null,
};

export const ReducerElegidos = (state, action) => {
  //console.log("ReducerElegidos", state, action);
  let nuevoEstado = state;
  switch (action.type) {
    case Filtros.PAIS: {
      return {
        ...state,
        pais: action.value,
        division: null,
        tipoTorneo: null,
        torneo: null,
        etapa: null,
        equipo: null,
      };
    }
    case Filtros.DIVISION: {
      if (!state.pais) {
        nuevoEstado = { ...state, pais: action.value.pais };
      }
      return {
        ...nuevoEstado,
        division: action.value,
        tipoTorneo: null,
        torneo: null,
        etapa: null,
        equipo: null,
      };
    }
    case Filtros.TIPO_TORNEO: {
      if (!state.pais && action.value && action.value.pais) {
        nuevoEstado = { ...state, pais: action.value.pais };
      }
      return {
        ...nuevoEstado,
        tipoTorneo: action.value,
        torneo: null,
        etapa: null,
        equipo: null,
      };
    }
    case Filtros.TORNEO: {
      if (!state.pais && action.value.pais) {
        nuevoEstado = {
          ...state,
          pais: action.value.pais,
          equipo: null,
        };
      }
      if (state.pais && !state.division) {
        nuevoEstado = {
          ...nuevoEstado,
          division: action.value.division,
        };
      }
      return {
        ...nuevoEstado,
        tipoTorneo: action.value.tipoTorneo,
        torneo: action.value,
        etapa: null,
      };
    }
    case Filtros.ETAPA: {
      return {
        ...state,
        etapa: action.value,
        equipo: null,
      };
    }
    case Filtros.EQUIPO: {
      return {
        ...state,
        equipo: action.value,
      };
    }
    case Reducer.INICIALIZAR: {
      return ReducerVacio;
    }
    case Reducer.VOLVER: {
      switch (action.value) {
        case '1': {
          return {
            ...state,
            division: null,
            torneo: null,
            etapa: null,
            equipo: null,
          };
        }
        case '2': {
          return {
            ...state,
            torneo: null,
            etapa: null,
            equipo: null,
          };
        }
        case '3': {
          return {
            ...state,
            etapa: null,
            equipo: null,
          };
        }
        default: {
          console.error('Tipo de reducer de torneos no recoocido: ' + action.type);
        }
      }
      break;
    }
    default: {
      return ReducerVacio;
    }
  }
};
